import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {withTranslation} from 'react-i18next';

/* Actions */

import LoginActions from '../../../actions/loginActions';

/* Components */

import Button from 'components/Button';
import Panel from 'components/Panel';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import ModalHeadline from 'components/ModalHeadline';

import AuthPageWrapper from './shared/AuthPageWrapper';

/* Utils */
import queryparse from 'tricks/string/queryparse';
import {validateEmailAddress} from 'utils/emails';

class ForgotPassword extends Component {
	constructor(props) {
		super(props);
		const {email} = queryparse(props.location.search);
		this.state = {
			alert: '',
			email: email || '',
		};
		this.resetPassword = this.resetPassword.bind(this);
		this.goBackToLogin = this.goBackToLogin.bind(this);
		this.changeHandler = this.changeHandler.bind(this);
		this.inputRef = this.inputRef.bind(this);
	}

	resetPassword(e) {
		e.preventDefault();

		const {t, history} = this.props;

		const input = this.inputReset.value.trim();
		const email = validateEmailAddress.test(input) ? input : null;

		if (email) {
			const reset = LoginActions.resetPassword({email});
			reset
				.then(() => {
					history.push('/password-requested');
				})
				.catch(err => {
					if (err?.code) {
						this.setState({alert: t(err.code)});
					} else {
						this.setState({alert: err?.message});
					}
				});
		} else {
			this.setState({alert: t('error_invalid_email')});
		}
	}

	goBackToLogin() {
		this.props.history.push('/login');
	}

	changeHandler(e) {
		const value = e.target.value.trim();
		this.setState({email: value});
	}

	inputRef(el) {
		this.inputReset = el;
	}

	render() {
		const {t} = this.props;

		return (
			<AuthPageWrapper>
				<form onSubmit={this.resetPassword}>
					<ModalHeadline
						title={t('forgot_pw_title')}
						onClose={this.goBackToLogin}
					/>
					<Panel>
						<p>{t('forgot_pw_description')}</p>
					</Panel>
					<Panel>
						<FormField label={t('email')} alert={this.state.alert}>
							<TextInput
								type="email"
								placeholder={t('email_placeholder')}
								autoComplete="username"
								spellCheck="false"
								autoCorrect="off"
								inputRef={this.inputRef}
								value={this.state.email}
								onChange={this.changeHandler}
							/>
						</FormField>
					</Panel>
					<Panel align="center">
						<Button
							id="send_password_reset_button"
							type="submit"
							variant="primary"
						>
							{t('forgot_pw_submit')}
						</Button>
					</Panel>
				</form>
			</AuthPageWrapper>
		);
	}
}

export default withRouter(withTranslation()(ForgotPassword));
